export default __webpack_public_path__ + "static/column-with-negative-values-6320cab08066a0202f5c0483734fc94a.png";